import { createContext } from "react";
import {ResolvedLocaleData} from "../../util/locale";
export interface LocalizeContextData extends ResolvedLocaleData {
  changeLanguage?: (l: string) => void;
}
const LocalizeContext = createContext<LocalizeContextData>({});

export default LocalizeContext;
